import React from "react";
import PrescriberNotesDialog from "../PrescriberNote/PrescriberNotesDialog";
import PrescriberCustomNoteDialog from "../PrescriberNote/PrescriberCustomNoteDialog";
import useMediaQuery from "@mui/material/useMediaQuery";
import LoaderWithIcon from "../CommonComponent/LoaderWithIcon";
const PrescriberNotesModal = ({
  isOpen,
  customNotePopupOpen,
  isLoadingPage,
  prescriberNoteResponse,
  additionalPrescriberNoteCriteria,
  currentPlanName,
  activeRow,
  contingentDataField,
  customNoteData,
  setOpen,
  setCustomNotePopupOpen,
  handlePopupClose,
  handlePopupOpen,
}) => {
  const matchesMobileWidth = useMediaQuery("(max-width:1032px)");

  const handleClose = () => {
    setOpen(false);
    handleClickOutside();
    handlePopupClose();
  };

  const handleClickOutside = () => {
    setOpen(false);
    setCustomNotePopupOpen(false);
    handlePopupClose();
  };

  const handleCustomNotePopupCloseEvent = () => {
    setCustomNotePopupOpen(false);
  };

  return (
    <>
      {isLoadingPage && (
        <div className="norstella-cf-overlay">
          <LoaderWithIcon></LoaderWithIcon>
        </div>
      )}
      {isOpen && <div onClick={handleClickOutside} part="cfOverlay" className="norstella-cf-overlay"></div>}
      <div className="norstella-cf-divPrescriberNotesDialogOuter">
        <PrescriberNotesDialog
          isOpen={isOpen}
          onClose={handleClose}
          isMobile={matchesMobileWidth}
          prescriberNoteResponse={prescriberNoteResponse}
          additionalPrescriberNoteCriteria={additionalPrescriberNoteCriteria}
          resultname={currentPlanName}
          row={activeRow}
          contingentDataField={contingentDataField}
          channelName={activeRow?.Channel || ""}
          onOpen={handlePopupOpen}
        />
      </div>
      {customNotePopupOpen && (
        <div onClick={handleClickOutside} part="cfOverlay" className="norstella-cf-overlay"></div>
      )}
      <div part="cfDivPrescriberCustomNoteDialogOuter" className="norstella-cf-divPrescriberCustomNoteDialogOuter">
        <PrescriberCustomNoteDialog
          isOpen={customNotePopupOpen}
          onClose={handleCustomNotePopupCloseEvent}
          noteDetails={customNoteData?.noteDetails}
          resultname={currentPlanName}
          channelName={activeRow?.Channel || ""}
        />
      </div>
    </>
  );
};

export default PrescriberNotesModal;
